export default class ShipperSaveDetail {
    constructor() {

        this.id = 0;
        this.name = '';
        this.addressLine1 = '';
        this.addressLine2 = '';
        this.city = '';
        this.county = '';
        this.postCode = '';
        this.country = '';
        this.vatNumber = '';
        this.contacts = [];
        this.isShipperAddress = true;
    }
}
